/* global appData */
/* global document */

import $ from 'jquery';

function getContent(endpoint) {
	//Header X-WP-Nonce
	return $.ajax({
		url: `${appData.root}${endpoint}`,
		headers: { 'X-WP-Nonce': appData.nonce }
	});
}

export const RestComponent = {
	data: () => ({
		content: null,
		getPostsResult: [],
		loading: false,
		resetOnce: false,
	}),
	computed: {
		transition: vm => vm.$store.state.pages.transition,
		transitionMode: vm => vm.$store.state.pages.transitionMode,
		createform: function () {
			if (this.content.createform) {
				return this.content.createform
			}

			return []
		},
		postId: function () {
			return this.$attrs['postId']
		}
	},
	beforeRouteEnter(to, from, next) {
		const endpoint = to.meta.endpoint;
		if (endpoint === null) {
			next();
		}
		// Get the content
		getContent(endpoint)
			.then(data => next((vm) => {
				vm.$data.content = data;
				vm.$data.transition = to.params.transition !== undefined ? to.params.transition : 'fade';
				vm.$route.meta.title = data.hasOwnProperty('metaTitle') ? data.metaTitle : 'Kirk Larsen & Ascanius';
				document.title = vm.$route.meta.title;
			}));
	},
	beforeRouteUpdate(to, from, next) {
		const endpoint = to.meta.endpoint;

		if (endpoint === null) {
			next();
		}

		// Get the content
		getContent(endpoint)
			.then(data => this.content = data)
			.then(() => next());
	},
	beforeRouteLeave(to, from, next) {
		this.loading = true;
		this.resetOnce = false;
		to.params.transition = this.transition;
		setTimeout(() => {
			next();
		}, 500);
	},
	watch: {
		content() {
			this.loading = false;
			if (!this.resetOnce) {
				this.resetOnce = true;
			}
		},
	},
	methods: {
		getPosts(endpoint) {
			$.get(`${appData.root}${endpoint}`)
				//Return result
				.then(content => this.getPostsResult = content);
		},
		navigateLeft(to) {
			this.$store.commit('pages/updateData', {
				name: 'isNavigating',
				value: true,
			});
			this.$store.commit('pages/updateData', {
				name: 'transition',
				value: 'slide',
			});
			this.$nextTick(function () {
				this.$router.push({ path: to, query: this.$route.query });
			});
		},
		navigateRight(to) {

			let query = null

			if (to != '/') {
				query = this.$route.query
			}

			this.$store.commit('pages/updateData', {
				name: 'isNavigating',
				value: true,
			});
			this.$store.commit('pages/updateData', {
				name: 'transition',
				value: 'slide-right',
			});

			this.$nextTick(function () {
				this.$router.push({ path: to, query: query });
			});
		},
		openPage(to) {
			this.$store.commit('pages/updateData', {
				name: 'isNavigating',
				value: true,
			});
			this.$store.commit('pages/updateData', {
				name: 'transition',
				value: 'fade',
			});
			this.$nextTick(function () {
				this.$router.push({ path: to, query: this.$route.query });
			});
		},
	},
	mounted() {
		this.$store.commit('pages/updateData', {
			name: 'isNavigating',
			value: false,
		});
	},
};







// WEBPACK FOOTER //
// ./assets/_js/mixins/rest-component.js